import { render, staticRenderFns } from "./ZBonPage.vue?vue&type=template&id=2125b0d6&scoped=true"
import script from "./ZBonPage.vue?vue&type=script&lang=js"
export * from "./ZBonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125b0d6",
  null
  
)

export default component.exports